import React, { useState } from 'react';
import CouponTable from '../components/CouponTable';
import CouponForm from '../components/CouponForm';
import styles from '../styles/Coupon.module.css';

const initialCoupons = [
  { id: 1, code: 'SAVE20', discount: 20, expiry: '2025-12-31', status: 'Active' },
  { id: 2, code: 'WELCOME10', discount: 10, expiry: '2024-08-15', status: 'Expired' },
  { id: 3, code: 'FESTIVE30', discount: 30, expiry: '2025-11-01', status: 'Active' },
  { id: 4, code: 'SPRING15', discount: 15, expiry: '2024-05-20', status: 'Active' },
  { id: 5, code: 'SUMMER25', discount: 25, expiry: '2024-07-31', status: 'Active' },
];

const Coupons = () => {
  const [coupons, setCoupons] = useState(initialCoupons);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const handleAdd = () => {
    setEditing(null);
    setShowForm(true);
  };

  const handleEdit = (coupon) => {
    setEditing(coupon);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Delete this coupon?')) {
      setCoupons(coupons.filter(c => c.id !== id));
      alert('Coupon deleted!');
    }
  };

  const handleFormSubmit = (form) => {
    if (editing) {
      setCoupons(coupons.map(c => c.id === editing.id ? { ...c, ...form } : c));
      alert('Coupon updated!');
    } else {
      setCoupons([
        ...coupons,
        { ...form, id: Date.now() },
      ]);
      alert('Coupon added!');
    }
    setShowForm(false);
    setEditing(null);
  };

  return (
    <div className={styles.couponsContainer}>
      <div className={styles.headerRow}>
        <h2>Coupons</h2>
        <button className={styles.addBtn} onClick={handleAdd}>Add Coupon</button>
      </div>
      {showForm && (
        <CouponForm
          onSubmit={handleFormSubmit}
          onCancel={() => { setShowForm(false); setEditing(null); }}
          editingCoupon={editing}
        />
      )}
      <CouponTable
        coupons={coupons}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default Coupons;